/* Zapply quiz funnel — generated from index.html, do not hand-edit */
(function () {
      'use strict';

      /* =========================================================
         CONFIG — overridable from the Shopify section via data-*
         ========================================================= */
      var ROOT = document.getElementById('zapply-quiz');
      /* Config comes from the Shopify section's data-* attributes, or from a
         window.ZQ_CONFIG object when the file is hosted standalone. */
      function cfg(name, fallback) {
        var v = ROOT && ROOT.dataset ? ROOT.dataset[name] : '';
        if (v === undefined || v === null || v === '') {
          var g = window.ZQ_CONFIG || {};
          v = g[name];
        }
        return (v === undefined || v === null || v === '') ? fallback : v;
      }

      var PRODUCT_URL = cfg('productUrl', 'https://tryzapply.com/products/zapply-tc-t1');
      /* spec S13: subscription pre-checked (Loop). Appending the selling plan
         lands the visitor with the subscription already selected. */
      var VARIANT_ID = cfg('variantId', '');
      if (VARIANT_ID && PRODUCT_URL.indexOf('variant=') === -1) {
        PRODUCT_URL += (PRODUCT_URL.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(VARIANT_ID);
      }

      var SELLING_PLAN = cfg('sellingPlan', '');
      if (SELLING_PLAN && PRODUCT_URL.indexOf('selling_plan') === -1) {
        PRODUCT_URL += (PRODUCT_URL.indexOf('?') === -1 ? '?' : '&') + 'selling_plan=' + encodeURIComponent(SELLING_PLAN);
      }
      var ENDPOINT = cfg('endpoint', '');          /* Apps Script /exec URL */
      var QUIZ_ID = cfg('quizId', 'zapply-quiz-v4');
      /* Real figures from tryzapply.com. Overridable from the theme editor. */
      var TRUSTPILOT = cfg('trustpilot', '4.8 Rating | 500+ verified reviews');

      var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Canonical survey base — one variable so the figure can never drift
         between screens (spec Part 5: never mix survey bases). */
      var STAT_FOOTNOTE = 'Based on 1,603 Zapply customers who used it for 30+ days. Individual results may vary.';

      /* =========================================================
         COPY / STEP MODEL

         Every step carries its positional number `n` (1-13). The Apps
         Script model only builds its funnel from numeric, numerically
         sorted steps, so these must stay positional. Route-specific
         steps share an `n` and are selected by `when`.
         ========================================================= */

      /* The three ranked spec headlines, each with the phrase to accent.
         `hl` must appear verbatim inside `t` or it is simply not highlighted. */
      var HEADLINES = [
        { t: "You don't feel like you did a few years ago. Let's find out why, and fix it.", hl: "Let's find out why" },
        { t: "Remember when you had energy to burn? Let's get that guy back.", hl: "Let's get that guy back." },
        { t: "The old you isn't gone. He's just buried under modern life.", hl: "The old you isn't gone." }
      ];

      function esc(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      function headlineHtml(o) {
        var i = o.hl ? o.t.indexOf(o.hl) : -1;
        if (i === -1) return esc(o.t);
        return esc(o.t.slice(0, i)) +
          '<span class="hl">' + esc(o.hl) + '</span>' +
          esc(o.t.slice(i + o.hl.length));
      }
      var SUBHEAD = 'A 2-minute check to find what slipped, why, and what actually brings it back. Built for men, backed by real testing. No magic-pill nonsense.';

      var ICON = {
        bolt: '<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>',
        /* focus, not a brain — a crosshair reads instantly at 22px */
        brain: '<circle cx="12" cy="12" r="7.5"/><circle cx="12" cy="12" r="2.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22"/>',
        scale: '<path d="M12 4v16M7 7h10M5 20h14M7 7 4 13h6zM17 7l-3 6h6z"/>',
        /* dumbbell, unmistakably strength */
        muscle: '<path d="M6.5 6.5v11M17.5 6.5v11M3.5 9.5v5M20.5 9.5v5M6.5 12h11"/>',
        spark: '<path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/><path d="m18 16 .9 2.1L21 19l-2.1.9L18 22l-.9-2.1L15 19l2.1-.9z"/>'
      };

      var STEPS = [
        /* ---- S1 opener + age ---- */
        {
          n: 1, key: 'age', hero: true,
          q: 'How old are you?',
          options: [{ t: 'Under 30' }, { t: '30-39' }, { t: '40-49' }, { t: '50+' }]
        },

        /* ---- S2 branch selector ---- */
        {
          n: 2, key: 'route',
          q: "When you think about it, what's slipped the most?",
          options: [
            { t: "I'm tired all the time, the energy's just gone", route: 'energy', icon: 'bolt' },
            { t: "My head's foggy, I can't focus like I used to", route: 'energy', icon: 'brain' },
            { t: "I've put on weight and can't shift it", route: 'body', goal: 'lose', icon: 'scale' },
            { t: "I'm losing muscle and strength, I can't build it like I used to", route: 'body', goal: 'gain', icon: 'muscle' },
            { t: "I've lost my edge and motivation, I'm not the man I was", route: 'drive', icon: 'spark' }
          ]
        },

        /* ---- S3 route question 1 ---- */
        {
          n: 3, key: 'q3', when: function (s) { return s.route === 'energy'; },
          q: 'By 3pm, how does your energy compare to when you woke up?',
          options: [
            { t: 'Running on empty, I need caffeine or a nap' },
            { t: 'Noticeably lower, the slump hits hard' },
            { t: 'A bit slower, but I push through' },
            { t: 'Steady, no real crash' }
          ]
        },
        {
          n: 3, key: 'q3', when: function (s) { return s.route === 'body' && s.goal === 'lose'; },
          q: "What's the weight doing right now?",
          options: [
            { t: "Settled around the middle and won't move" },
            { t: 'Creeping up no matter what I do' },
            { t: 'I lose a bit, then it comes straight back' },
            { t: 'Not much changes either way' }
          ]
        },
        {
          n: 3, key: 'q3', when: function (s) { return s.route === 'body' && s.goal === 'gain'; },
          q: 'What happens when you train?',
          options: [
            { t: "I put the work in but the size won't come" },
            { t: "I've lost muscle I used to have" },
            { t: 'My strength has stalled or slipped' },
            { t: 'I recover way slower than I used to' }
          ]
        },
        {
          n: 3, key: 'q3', when: function (s) { return s.route === 'drive'; },
          q: "How's your drive and motivation compared to a few years ago?",
          options: [
            { t: "Barely there, I'm running on fumes" },
            { t: 'Noticeably down' },
            { t: 'Comes and goes' },
            { t: 'Still solid' }
          ]
        },

        /* ---- S4 route question 2 ---- */
        {
          n: 4, key: 'q4', when: function (s) { return s.route === 'energy'; },
          q: "When the crash hits, what's the first thing that suffers?",
          options: [
            { t: 'The training I planned to do' },
            { t: 'My patience at home' },
            { t: 'The work I actually care about' },
            { t: 'Nothing, I just push through on caffeine' }
          ],
          why: "The afternoon crash usually isn't willpower. Blood sugar swings, poor recovery, and steady stress pull your energy down together, and as natural testosterone dips with age that recovery signal gets weaker. We're mapping which one is hitting you hardest."
        },
        {
          n: 4, key: 'q4', when: function (s) { return s.route === 'body'; },
          q: 'What have you already tried?',
          options: [
            { t: "Cut calories or dieted, it didn't hold" },
            { t: 'Trained harder, saw no change' },
            { t: 'Started and stopped a few times' },
            { t: "Not much yet, don't know where to start" }
          ],
          why: "After the mid-30s, natural testosterone and recovery both slide, so the same training and diet that used to work stops landing. It's not that you got lazy. The engine changed."
        },
        {
          n: 4, key: 'q4', when: function (s) { return s.route === 'drive'; },
          q: 'Where do you feel it most?',
          options: [
            { t: 'Getting up for things I used to chase' },
            { t: 'My mood and patience at home' },
            { t: 'My confidence' },
            { t: 'My libido' }
          ],
          why: "Drive, mood, and libido tend to move together, because they ride on the same systems. When energy and testosterone dip, they usually dip as a set. It's common, and it's one of the things men say shifts first."
        },

        /* ---- S5 reframe ---- */
        { n: 5, key: 'proof', screen: 's-proof', title: 'Route proof', when: function (s) { return reviewsFor(s.route).length > 0; } },
        { n: 6, key: 'reframe', screen: 's-reframe', title: 'Reframe' },

        /* ---- S6 timeline (not scored) ---- */
        {
          n: 7, key: 'timeline',
          q: "When did you first notice things weren't the same?",
          options: [
            { t: 'Over a year ago' },
            { t: 'In the past year' },
            { t: 'In the past few months' },
            { t: 'Honestly not sure' }
          ]
        },

        /* ---- S7 sleep (SCORING) ---- */
        {
          n: 8, key: 'sleep',
          q: 'How many hours of solid sleep do you usually get?',
          options: [
            { t: 'Less than 5', high: true },
            { t: '5-6', high: true },
            { t: '7-8' },
            { t: 'More than 8' }
          ],
          why: 'A lot of your recovery and natural hormone production happens in deep sleep. Short or broken nights cap how much your body can rebuild, no matter how clean everything else is.'
        },

        /* ---- S8 stress (SCORING) ---- */
        {
          n: 9, key: 'stress',
          q: 'How often do you feel wired, foggy, or burned out during the day?',
          options: [
            { t: "Constant, that's my normal now", high: true },
            { t: 'Most days, it builds by afternoon', high: true },
            { t: 'Some days, it comes and goes' },
            { t: 'Rarely, I stay pretty even' }
          ],
          why: 'Chronic stress keeps cortisol high, and high cortisol works against recovery and drive. When your body stays in defense mode, it stops rebuilding.'
        },

        /* ---- S9 diet (SCORING) ---- */
        {
          n: 10, key: 'diet',
          q: 'How much of what you eat is convenience or processed food?',
          options: [
            { t: 'Most meals', high: true },
            { t: 'Daily', high: true },
            { t: 'A few times a week' },
            { t: 'Rarely' }
          ],
          why: 'Modern processed food carries fewer of the minerals your body needs to make energy than it did a generation ago. Even a decent diet can leave real gaps.'
        },

        /* ---- S10-13 content screens ---- */
        { n: 11, key: 'loading', screen: 's-loading', title: 'Loading' },
        { n: 12, key: 'result', screen: 's-result', title: 'Result' },
        { n: 13, key: 'future', screen: 's-future', title: 'Where it can go' },
        { n: 14, key: 'offer', screen: 's-offer', title: 'Offer' },
        { n: 15, key: 'finalise', screen: 's-final', title: 'Finalising' }
      ];

      var LAST_N = STEPS[STEPS.length - 1].n;

      /* Steps 3 and 4 branch by route. The Apps Script model keeps one title
         per step number (last write wins), so both report a stable,
         route-neutral label. The answer text identifies the route, and Q2's
         answer gives clean per-route segmentation. */
      function reportTitle(step) {
        if (step.n === 3) return 'Q3 · route question (energy / body / drive)';
        if (step.n === 4) return 'Q4 · route question (energy / body / drive)';
        return step.q || step.title || ('Step ' + step.n);
      }

      /* =========================================================
         RESULT ENGINE (spec Part 2) — deterministic
         ========================================================= */

      var DRIVERS = {
        sleep: { label: 'sleep debt', name: 'Sleep debt', copy: "You're not getting the deep sleep your body recovers and rebuilds in." },
        stress: { label: 'chronic stress', name: 'Chronic stress', copy: 'Cortisol staying high keeps your body in defense mode instead of rebuild mode.' },
        diet: { label: 'nutrient gaps', name: 'Nutrient gaps', copy: 'Modern processed food leaves out minerals your body needs to make energy.' }
      };

      var PATTERNS = {
        'energy': { name: 'Running On Reserve', line: 'Your energy and focus hold in the morning, then fade by mid-afternoon.' },
        'body:lose': { name: 'The Stubborn Middle', line: 'The weight settled on and stopped responding to the effort that used to shift it.' },
        'body:gain': { name: 'The Plateau', line: 'You put the work in, but the size and strength stopped coming like they used to.' },
        'drive': { name: 'Lost A Step', line: 'Your drive and edge have slipped from where they used to be.' }
      };

      var FUTURE = {
        'energy': { stat: true, text: '<b>83% of the men we surveyed reported more energy through the day</b>, and for around 1 in 3, the afternoon crash stopped.' },
        'drive': { stat: true, text: '<b>79% reported more motivation and drive. 70% reported improved libido.</b>' },
        'body:lose': { stat: false, text: "When your body runs on low testosterone, it holds onto fat and fights you the whole way. Support the root cause and the effort you're already putting in starts landing again. It's not a weight-loss pill, and it's not overnight. <b>90 days to feel the difference, or your money back.</b>" },
        'body:gain': { stat: false, text: "Low testosterone caps how much muscle you can build and hold, however hard you train. Support the root cause and the work starts paying off again. It's not a magic pill, you still have to put the reps in. <b>90 days to feel it, or your money back.</b>" }
      };

      /* Fixed tiebreak order: Sleep > Stress > Diet */
      var FACTOR_ORDER = ['sleep', 'stress', 'diet'];

      function isHigh(key) {
        var step = findStep(key);
        var idx = state.answers[key];
        if (!step || idx === undefined) return false;
        return !!step.options[idx].high;
      }

      function routeKey() {
        return state.route === 'body' ? ('body:' + (state.goal || 'lose')) : (state.route || 'energy');
      }

      function computeResult() {
        var flags = {};
        FACTOR_ORDER.forEach(function (f) { flags[f] = isHigh(f); });

        var highs = FACTOR_ORDER.filter(function (f) { return flags[f]; });
        var lows = FACTOR_ORDER.filter(function (f) { return !flags[f]; });
        /* HIGH above LOW; order inside each group is already the tiebreak */
        var ranked = highs.concat(lows);
        var highCount = highs.length;

        var pattern = PATTERNS[routeKey()] || PATTERNS.energy;
        var allLow = highCount === 0;

        return {
          route: routeKey(),
          pattern: pattern.name,
          routeLine: pattern.line,
          lever: allLow ? 'the natural dip that comes with age and modern load' : DRIVERS[ranked[0]].label,
          allLow: allLow,
          highCount: highCount,
          ranked: ranked,
          flags: flags,
          /* 3 highs = far left (Low) … 0 = right (Steady) */
          scalePct: { 3: 12.5, 2: 37.5, 1: 62.5, 0: 87.5 }[highCount],
          scaleLabel: ['Steady', 'Centre-right', 'Centre-left', 'Low'][highCount]
        };
      }

      /* =========================================================
         REVIEWS (S10)

         PASTE REAL TRUSTPILOT REVIEWS HERE. Never write or edit a review
         to fit a route (spec Part 5). Tag each with
         theme: 'energy' | 'body' | 'drive' | 'general'.
         Shape: { name:'James', stars:5, quote:'...', theme:'energy', verified:true }
         A route with fewer than 2 tagged reviews falls back to 'general'.
         Left empty, the review column is simply omitted.
         ========================================================= */
      var REVIEWS = [
        {
          "name": "Colin S",
          "quote": "Been using for 6 months now really great product I’m a 55 yr old man really helps great energy defo feel 15 years younger I recommend to all my friends 5 stars from me",
          "stars": 5,
          "theme": "energy",
          "verified": true
        },
        {
          "name": "Scott C",
          "quote": "Only been taking it just over three weeks but I have noticed a different in sleep the most plus a massive difference in energy.  Looking forward to what happens in the coming months 💪",
          "stars": 5,
          "theme": "energy",
          "verified": true
        },
        {
          "name": "Liam B",
          "quote": "Slept better after the first few days. Noticed a great change in the quality of my sleep and the lack on grogginess in the morning. More energy in the day",
          "stars": 5,
          "theme": "energy",
          "verified": true
        },
        {
          "name": "Ian M",
          "quote": "So before taking the supplement I was always really tired at work. I've not really been back at the gym so I don't know how it works with me at the gym but I'm now less tired and more awake",
          "stars": 5,
          "theme": "energy",
          "verified": true
        },
        {
          "name": "Anthony J",
          "quote": "Was very dubious at first but took 4 weeks to feel an effect- i do have more energy,not only feel better in the gym but also more stamina when out cycling,genuine review from a 53 yr old guy!!",
          "stars": 5,
          "theme": "body",
          "verified": true
        },
        {
          "name": "Mark G",
          "quote": "Since taking zapply I have noticed a significant increase in muscle growth and my hair has started to thicken too. I have more energy and an increase in stamina. I would highly recommend to everyone",
          "stars": 5,
          "theme": "body",
          "verified": true
        },
        {
          "name": "Sean W",
          "quote": "I’ve been using this product almost 3 weeks now and have noticed a huge change in energy and recovery levels, would highly recommend.",
          "stars": 5,
          "theme": "body",
          "verified": true
        },
        {
          "name": "James A",
          "quote": "It has given me more go ive got more energy. Its given a boost to the gym. I have found its helped a little with the brain fog. The creatine I found was very good as a pre gym drink I am enjoying this product.",
          "stars": 5,
          "theme": "body",
          "verified": true
        },
        {
          "name": "Matthew T",
          "quote": "After a few weeks I started to feel more energy, a better mood and generally feeling good. After 6 weeks I noticed that I had lost weight.",
          "stars": 5,
          "theme": "drive",
          "verified": true
        },
        {
          "name": "Mark B",
          "quote": "Been taking Zapply now for about 4 weeks and starting to feel better now with my mood and energy",
          "stars": 5,
          "theme": "drive",
          "verified": true
        },
        {
          "name": "Shaun",
          "quote": "Very overt good product, really happy with this. More active alert and energegetic, mood has been also been top for",
          "stars": 5,
          "theme": "drive",
          "verified": true
        },
        {
          "name": "John",
          "quote": "These tablets give you more energy and lift your mood, I'm impressed with them so far, bought the 90 day package",
          "stars": 5,
          "theme": "drive",
          "verified": true
        },
        {
          "name": "Richard G",
          "quote": "Only been taking it about 2 weeks and feel a big difference in myself was skeptical but thought I’d give it a try after reading all the reviews and glad I did",
          "stars": 5,
          "theme": "general",
          "verified": true
        },
        {
          "name": "James S",
          "quote": "Great product, I do feel better as a result. Just so you are aware, you do have to use it for a month or 2 to feel results!",
          "stars": 5,
          "theme": "general",
          "verified": true
        },
        {
          "name": "Nathan P",
          "quote": "Changed my life I feel great thanks! Would be even better with lions mane added but it’s fine I get that separate.",
          "stars": 5,
          "theme": "general",
          "verified": true
        },
        {
          "name": "Paul W",
          "quote": "Was a little unsure at first but notice a difference about 3 weeks in and Ordered another 90 days worth and will order again as I can now feel the difference through the day and first thing in the morning waking up! ( 50 yrs old )",
          "stars": 5,
          "theme": "general",
          "verified": true
        }
      ];

      /* On Shopify the reviews come from the section's blocks, injected as JSON
         so they can be managed in the theme editor without a rebuild. Anything
         found there replaces the array above. */
      (function () {
        try {
          var el = document.getElementById('zq-reviews');
          if (!el || !el.textContent.trim()) return;
          var parsed = JSON.parse(el.textContent);
          if (parsed && parsed.length) REVIEWS = parsed;
        } catch (e) { }
      })();

      function reviewsFor(route) {
        var matched = REVIEWS.filter(function (r) { return r.theme === route; });
        if (matched.length < 2) matched = REVIEWS.filter(function (r) { return r.theme === 'general'; });
        return matched.slice(0, 3);
      }

      /* =========================================================
         TRACKING — Apps Script (Code.gs) + GA4 / Triple Whale
         ========================================================= */

      function sessionId() {
        var k = 'zq_sid', v = '';
        try { v = sessionStorage.getItem(k) || ''; } catch (e) { }
        if (!v) {
          v = 's_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
          try { sessionStorage.setItem(k, v); } catch (e) { }
        }
        return v;
      }
      var SID = sessionId();

      function post(payload) {
        if (!ENDPOINT) return;
        var body = JSON.stringify(payload);
        /* Beacon survives the redirect on the final CTA, where a normal fetch
           would be cancelled mid-flight and the event lost. text/plain avoids
           a CORS preflight; Apps Script reads e.postData.contents regardless,
           so JSON.parse still works. */
        try {
          if (navigator.sendBeacon) {
            navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
            return;
          }
        } catch (e) { }
        try {
          fetch(ENDPOINT, {
            method: 'POST', mode: 'no-cors', keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body
          });
        } catch (e) { }
      }

      function track(event, opts) {
        opts = opts || {};
        var payload = {
          event: event,
          step: (opts.step === undefined || opts.step === null) ? '' : String(opts.step),
          title: opts.title || '',
          answer: opts.answer || '',
          is_multi: !!opts.is_multi,
          session_id: SID,
          quiz_id: QUIZ_ID,
          client_ts: new Date().toISOString(),
          ua: navigator.userAgent || '',
          ref: document.referrer || ''
        };
        post(payload);

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'zq_' + event, zq: payload });
        } catch (e) { }
        try { if (typeof window.gtag === 'function') window.gtag('event', 'zq_' + event, payload); } catch (e) { }
        try { if (window.TriplePixel) window.TriplePixel('Custom', { event: 'zq_' + event, step: payload.step }); } catch (e) { }
      }

      /* =========================================================
         STATE + FLOW
         ========================================================= */

      var state = { i: 0, answers: {}, route: '', goal: '', timers: [] };
      var flow = [];

      function $(s, c) { return (c || document).querySelector(s); }
      function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
      function clearTimers() { state.timers.forEach(clearTimeout); state.timers = []; }
      function later(fn, ms) { var t = setTimeout(fn, REDUCED ? Math.min(ms, 120) : ms); state.timers.push(t); return t; }

      function buildFlow() {
        flow = STEPS.filter(function (s) { return !s.when || s.when(state); });
        return flow;
      }
      function findStep(key) {
        for (var i = 0; i < flow.length; i++) if (flow[i].key === key) return flow[i];
        for (var j = 0; j < STEPS.length; j++) if (STEPS[j].key === key) return STEPS[j];
        return null;
      }
      function current() { return flow[state.i]; }

      function persist() {
        try {
          sessionStorage.setItem('zq_state', JSON.stringify({
            answers: state.answers, route: state.route, goal: state.goal, i: state.i
          }));
        } catch (e) { }
      }
      function restore() {
        try {
          var raw = sessionStorage.getItem('zq_state');
          if (!raw) return false;
          var s = JSON.parse(raw);
          state.answers = s.answers || {};
          state.route = s.route || '';
          state.goal = s.goal || '';
          buildFlow();
          state.i = Math.min(s.i || 0, flow.length - 1);
          return true;
        } catch (e) { return false; }
      }

      /* =========================================================
         RENDERING
         ========================================================= */

      function svg(path, cls) {
        return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' viewBox="0 0 24 24" aria-hidden="true">' + path + '</svg>';
      }

      function renderQuestion(step) {
        var hero = $('#qHero'), claim = $('#qClaim'), trust = $('#qTrust'), quote = $('#qQuote');

        if (step.hero) {
          var angle = parseInt(new URLSearchParams(location.search).get('angle') || '1', 10);
          if (!(angle >= 1 && angle <= HEADLINES.length)) angle = 1;
          hero.innerHTML = headlineHtml(HEADLINES[angle - 1]);
          hero.hidden = false;

          $('#qSub').textContent = SUBHEAD;
          claim.hidden = false;

          $('#qTrustText').textContent = TRUSTPILOT;
          trust.hidden = false;

          /* The testimonial is only shown when a real review exists in the
             pool — never fabricated to fill the slot (spec Part 5). */
          var r = REVIEWS[0];
          if (r) {
            var s = '';
            for (var n = 0; n < (r.stars || 5); n++) {
              s += svg('<path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7.3L12 17.7 5.8 21.5l1.6-7.3L2 9.5l7.1-.6z"/>');
            }
            $('#qQuoteStars').innerHTML = s;
            $('#qQuoteScore').textContent = (r.stars || 5).toFixed(1);
            $('#qQuoteText').textContent = r.quote;
            $('#qQuoteWho').textContent = r.name;
            $('#qQuoteAv').textContent = r.name.charAt(0).toUpperCase();
            $('#qQuoteBadge').hidden = !r.verified;
            quote.hidden = false;
          } else {
            quote.hidden = true;
          }
        } else {
          hero.hidden = true;
          claim.hidden = true;
          trust.hidden = true;
          quote.hidden = true;
        }

        $('#qTitle').textContent = step.q;

        var wrap = $('#qOpts');
        wrap.innerHTML = '';
        wrap.dataset.locked = '0';

        step.options.forEach(function (o, idx) {
          var b = document.createElement('button');
          b.className = 'opt';
          b.type = 'button';
          b.style.setProperty('--i', idx);
          b.innerHTML =
            (o.icon ? '<span class="ico">' + svg(ICON[o.icon]) + '</span>' : '') +
            '<span class="lbl">' + o.t + '</span>' +
            '<span class="mark">' + svg('<path d="M20 6L9 17l-5-5"/>') + '</span>';
          if (state.answers[step.key] === idx) b.classList.add('sel');
          b.addEventListener('click', function () { pick(step, idx, wrap, b); });
          wrap.appendChild(b);
        });

        var why = $('#qWhy');
        if (step.why) { $('#qWhyText').textContent = step.why; why.hidden = false; }
        else why.hidden = true;
      }

      function pick(step, idx, wrap, btn) {
        if (wrap.dataset.locked === '1') return;
        wrap.dataset.locked = '1';
        state.answers[step.key] = idx;

        var opt = step.options[idx];

        if (step.key === 'route') {
          state.route = opt.route;
          state.goal = opt.goal || '';
          buildFlow();
          track('route_selected', { step: step.n, answer: state.route + (state.goal ? ':' + state.goal : '') });
        }
        if (step.key === 'age') track('age_selected', { step: step.n, answer: opt.t });

        track('answer', { step: step.n, title: reportTitle(step), answer: opt.t });
        track('q_answered', { step: step.n, answer: opt.t });

        $$('.opt', wrap).forEach(function (el) {
          if (el === btn) el.classList.add('sel'); else el.classList.add('dim');
        });

        persist();
        later(next, 400);
      }

      /* ---------- navigation ---------- */
      function go(index, dir) {
        clearTimers();
        buildFlow();
        state.i = Math.max(0, Math.min(index, flow.length - 1));
        var step = current();

        $$('.screen').forEach(function (s) { s.classList.remove('active', 'rise'); });

        var el;
        if (step.screen) el = document.getElementById(step.screen);
        else { el = document.getElementById('s-question'); renderQuestion(step); }

        el.classList.add('active');
        void el.offsetWidth;
        el.classList.add('rise');

        updateChrome(step);
        var a = $('#stagearea'); if (a) a.scrollTop = 0;
        persist();

        track('view', { step: step.n, title: reportTitle(step) });
        onEnter(step, dir);
      }

      function next() { go(state.i + 1, 'fwd'); }
      function back() { go(state.i - 1, 'back'); }

      function updateChrome(step) {
        var prog = $('#prog'), bar = $('#progBar'), bk = $('#back');
        prog.classList.toggle('on', step.n > 1);
        bar.style.width = Math.round((step.n / LAST_N) * 100) + '%';
        /* no stepping back into or out of the analysis */
        var canBack = state.i > 0 && step.key !== 'loading' && step.key !== 'result' && step.key !== 'finalise';
        bk.classList.toggle('on', canBack);
      }

      $('#back').addEventListener('click', back);
      $$('[data-next]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = current();
          if (step && step.key === 'reframe') track('reframe_continue', { step: step.n });
          next();
        });
      });

      /* =========================================================
         SCREEN HOOKS
         ========================================================= */

      var LOAD_STEPS = ['Reading your answers', 'Matching the pattern', 'Finding your biggest lever', 'Putting your plan together'];

      var PROOF_LINE = {
        'energy': 'Men who came to us for energy are usually the first to notice the shift. Here is what they said.',
        'body:lose': 'Men working on exactly what you are working on. Here is what they said.',
        'body:gain': 'Men chasing exactly the result you are after. Here is what they said.',
        'drive': 'Men who came to us for drive and motivation. Here is what they said.'
      };

      /* shared review-card markup, used by the proof screen and the loader */
      function reviewCards(pool) {
        return pool.map(function (r, i) {
          var stars = '';
          for (var s = 0; s < (r.stars || 5); s++) {
            stars += svg('<path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7.3L12 17.7 5.8 21.5l1.6-7.3L2 9.5l7.1-.6z"/>');
          }
          return '<div class="rev" style="--i:' + i + '"><div class="rev-top">' +
            '<span class="rev-name">' + r.name + '</span>' +
            (r.verified ? '<span class="rev-badge">' + svg('<path d="M12 2l2.4 2.1 3.1-.5 1.2 2.9 2.9 1.2-.5 3.1L23 13l-2.1 2.4.5 3.1-2.9 1.2-1.2 2.9-3.1-.5L12 24l-2.4-2.1-3.1.5-1.2-2.9-2.9-1.2.5-3.1L1 13l2.1-2.4-.5-3.1 2.9-1.2 1.2-2.9 3.1.5z"/><path d="M10.6 16.2l-3.1-3.1 1.3-1.3 1.8 1.8 4.6-4.6 1.3 1.3z" fill="#fff"/>') + 'Verified</span>' : '') +
            '<span class="stars">' + stars + '</span>' +
            '<span class="rev-score">' + (r.stars || 5).toFixed(1) + '</span>' +
            '</div>' + '<span class="quote-ico">' + svg('<path d="M10 7.5C7.4 9 6 11.4 6 14.2V17h5.2v-5.2H8.7c.1-1.6.9-2.8 2.3-3.6zM19.3 7.5c-2.6 1.5-4 3.9-4 6.7V17h5.2v-5.2H18c.1-1.6.9-2.8 2.3-3.6z"/>') + '</span>' + '<q>' + r.quote + '</q></div>';
        }).join('');
      }

      function renderProof() {
        $('#proofLine').textContent = PROOF_LINE[routeKey()] || PROOF_LINE.energy;
        $('#proofReviews').innerHTML = reviewCards(reviewsFor(state.route));
      }

      var FINAL_STEPS = [
        'Locking in your 90-day plan',
        'Activating your money-back guarantee',
        'Loading your custom offer'
      ];

      /* generic sequential checklist, shared by both loaders */
      function runChecklist(host, labels, done) {
        host.innerHTML = labels.map(function (t) {
          return '<div class="step"><span class="stxt">' + t + '</span><span class="sstat">' +
            '<span class="dot"></span><span class="ring"></span>' +
            svg('<path d="M20 6L9 17l-5-5"/>', 'chk') + '</span></div>';
        }).join('');
        var rows = $$('.step', host);
        var per = REDUCED ? 130 : 850;
        rows.forEach(function (r, k) {
          later(function () { r.classList.add('run'); }, k * per);
          later(function () { r.classList.remove('run'); r.classList.add('done'); }, k * per + per - 60);
        });
        later(done, rows.length * per + 450);
      }

      function onEnter(step) {
        if (step.key === 'proof') renderProof();
        if (step.key === 'finalise') {
          /* mirror the offer card's shot and label so the wait shows exactly
             what is being locked in */
          var shot = $('#pshot'), fshot = $('#finalShot');
          if (shot && fshot) fshot.src = shot.currentSrc || shot.src;
          $('#finalLabel').textContent = $('#offerTop').textContent;
          runChecklist($('#finalSteps'), FINAL_STEPS, redirect);
        }
        if (step.key === 'reframe') {
          $('#reframeFootnote').textContent = STAT_FOOTNOTE;
          /* the editorial image is optional (spec Part 3) — shown only if set */
          var ri = cfg('reframeImage', '');
          var img = $('#reframeImg');
          if (ri) { img.src = ri; img.hidden = false; } else img.hidden = true;
        }
        if (step.key === 'loading') runLoading();
        if (step.key === 'result') {
          renderResult();
          track('result_view', { step: step.n });
          track('complete', { step: 'results' });
        }
        if (step.key === 'future') renderFuture();
        if (step.key === 'offer') { renderOffer(); track('offer_view', { step: step.n }); }
      }

      function runLoading() {
        /* two cards beside the checklist; the proof screen shows the full set */
        var pool = reviewsFor(state.route).slice(0, 2);
        var box = $('#loadReviews'), wrap = $('#loadWrap');

        if (pool.length) {
          box.innerHTML = reviewCards(pool);
          box.hidden = false;
          wrap.classList.add('has-reviews');
          track('review_view', { step: 11, answer: state.route, is_multi: pool.length > 1 });
        } else {
          box.hidden = true;
          wrap.classList.remove('has-reviews');
        }

        var host = $('#loadSteps');
        host.innerHTML = LOAD_STEPS.map(function (t) {
          return '<div class="step"><span class="stxt">' + t + '</span><span class="sstat">' +
            '<span class="dot"></span><span class="ring"></span>' +
            svg('<path d="M20 6L9 17l-5-5"/>', 'chk') + '</span></div>';
        }).join('');

        var rows = $$('.step', host);
        var per = REDUCED ? 130 : 950;
        rows.forEach(function (r, k) {
          later(function () { r.classList.add('run'); }, k * per);
          later(function () { r.classList.remove('run'); r.classList.add('done'); }, k * per + per - 60);
        });

        var total = rows.length * per;
        var pctEl = $('#loadPct');
        var t0 = null;
        function frame(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / total);
          pctEl.textContent = Math.round(k * 100) + '%';
          if (k < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);

        later(function () { track('loading_complete', { step: 11 }); next(); }, total + 500);
      }

      function renderResult() {
        var r = computeResult();

        $('#rPattern').textContent = r.pattern;
        $('#rRouteLine').textContent = r.routeLine;
        $('#rLever').innerHTML = 'Your biggest lever right now is <b>' + r.lever + '</b>.';

        $('#rScaleChip').textContent = r.scaleLabel;

        var knob = $('#rKnob');
        knob.style.left = '12.5%';
        later(function () { knob.style.left = r.scalePct + '%'; }, 220);

        var ranks = ['Main driver', 'Compounding factor', 'Lifestyle load'];
        $('#rDrivers').innerHTML = r.ranked.map(function (f, i) {
          var d = DRIVERS[f];
          return '<div class="driver' + (i === 0 && !r.allLow ? ' main' : '') + '" style="--i:' + i + '">' +
            '<span class="num">' + (i + 1) + '</span>' +
            '<div>' +
            '<div class="rank">' + ranks[i] + '</div>' +
            '<h5>' + d.name + '</h5><p>' + d.copy + '</p>' +
            '</div></div>';
        }).join('');
      }

      function renderFuture() {
        var f = FUTURE[routeKey()] || FUTURE.energy;
        $('#fReceipt').innerHTML = f.text;
        var fn = $('#fFootnote');
        /* the footnote appears only where a stat actually shows (spec Part 5) */
        if (f.stat) { fn.textContent = STAT_FOOTNOTE; fn.hidden = false; }
        else fn.hidden = true;
      }

      var PROOF = [
        'Third-party tested and certified by Eurofins',
        'Real clinical doses',
        'Made in Europe',
        '90-day money-back guarantee'
      ];

      function renderOffer() {
        var items = PROOF.slice();
        if (TRUSTPILOT) items.push(TRUSTPILOT);
        $('#proofStack').innerHTML = items.map(function (t) {
          return '<span>' + svg('<path d="M20 6L9 17l-5-5"/>') + t + '</span>';
        }).join('');
      }

      $('#offerCta').addEventListener('click', function () {
        track('cta', { step: 14, answer: routeKey() });
        track('cta_click', { step: 14, answer: routeKey() });
        next();
      });

      function redirect() { window.location.href = PRODUCT_URL; }

      /* =========================================================
         MISC
         ========================================================= */

      $('#logo').addEventListener('error', function () {
        this.style.display = 'none';
        $('#logoFb').style.display = 'block';
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace') {
          e.preventDefault();
          if ($('#back').classList.contains('on')) back();
          return;
        }
        var step = current();
        if (!step) return;
        if (/^[1-9]$/.test(e.key) && !step.screen) {
          var t = $$('#qOpts .opt')[parseInt(e.key, 10) - 1];
          if (t) t.click();
          return;
        }
        if (e.key === 'Enter') {
          var b = $('.screen.active [data-next]') || $('.screen.active #offerCta');
          if (b) b.click();
        }
      });

      /* exposed for the verification harness only */
      window.__zq = {
        get state() { return state; },
        get flow() { return flow; },
        STEPS: STEPS, DRIVERS: DRIVERS, PATTERNS: PATTERNS, FUTURE: FUTURE,
        computeResult: computeResult, routeKey: routeKey,
        go: go, next: next, back: back, buildFlow: buildFlow
      };

      /* =========================================================
         BOOT
         ========================================================= */
      buildFlow();
      restore();
      track('quiz_start', { step: 1 });
      go(state.i, 'fwd');

    })();
